/// <amd-module name="WidgetCommon/CommonChartCacheableQueries/CommonChartConfigurationCacheableQuery" />
import { IVssPageContext } from "VSS/Platform/Context";

import { decodeHtmlSpecialChars } from "VSS/Features/Charts/Internal/StringUtilities";

import { ICacheableQuery } from "Reporting/Common/ICacheableQuery";
import { ChartConfiguration } from "Tfs/Charting/Contracts/Reporting";
import { IReportingRestClient } from "Tfs/Charting/RestClient/Reporting";

export class CommonChartConfigurationCacheableQuery implements ICacheableQuery<ChartConfiguration> {
    constructor(private projectId: string, private chartId: string) {}

    public async runQuery(pageContext: IVssPageContext): Promise<ChartConfiguration> {
        const reportingRestClient = pageContext.getRestClient<IReportingRestClient>("IReportingRestClient");

        const chartConfigurationResponse = await reportingRestClient.getChartConfiguration(this.projectId, this.chartId);
        const chartConfiguration = chartConfigurationResponse.chartConfiguration;
        chartConfiguration.title = decodeHtmlSpecialChars(chartConfiguration.title);

        return Promise.resolve(chartConfiguration);
    }

    public getKey(): string {
        return JSON.stringify({
            chartId: this.chartId
        });
    }
}
